import logo from '@/assets/client-admin-logo.png';

/** App logo at the top of the left menu (like CRM's logo there). The PNG is the
 *  "Client Administration" logo with its white background made transparent so it
 *  sits cleanly on the grey menu. */
export function AppWordmark() {
  return <img src={logo} alt="Client Administration" className="h-auto w-44 max-w-full h-md:w-52" />;
}
